import Debug from 'debug'
import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { ErrorHandlingScorm2004Client, ErrorHandlingScorm2004ClientSymbol } from '@/app/tracking/scorm/2004/client';
import { UpdateCourseScoreCommandPayload,
         UpdateCourseScoreCommand } from '../api';
import { parseReal } from '@/app/tracking/scorm/2004/api';
import { scaleScore } from '@/app/shared/utils/scale-score';

const debug = Debug('scorm2004-update-course-score-command-handler')

@injectable()
export class Scorm2004UpdateCourseScoreCommandHandler implements CommandHandler<UpdateCourseScoreCommand> {

  constructor(
    @inject(ErrorHandlingScorm2004ClientSymbol)
    private readonly client: ErrorHandlingScorm2004Client) {
  }

  public async execute(command: UpdateCourseScoreCommandPayload) {

    const score = command.score
    debug('execute', score.min, score.max, score.raw)

    const isUpdateRequired = command.alwaysOverwrite || await this.isScoreUpdateRequired(score.raw)
    debug('isUpdateRequired', isUpdateRequired)

    if (!isUpdateRequired) {
      return
    }

    const scaled = scaleScore(score, { min: -1, max: 1 })
    const items: Array<[string, any]>  = [
      [ 'cmi.score.raw', score.raw ],
      [ 'cmi.score.min', score.min ],
      [ 'cmi.score.max', score.max ],
      [ 'cmi.score.scaled', scaled ]
    ];

    debug('updating score', score.min, score.max, score.raw, 'scaled: ', scaled)

    this.client.setValues(items);
    this.client.commit();
  }

  private async isScoreUpdateRequired(score: number) {
    const currentResult = await this.client.getValue('cmi.score.raw')
    debug('current', currentResult, 'new', score)
    if (!currentResult.success) {
      return false
    }

    const parseResult = parseReal(currentResult.value)
    debug('parse result', parseResult)
    if (!parseResult.success) {
      return true
    }

    return score > parseResult.value
  }

}
